/**!  
 * Utility Scripts  
 * 
 **/

// Just a test
// export var test = 42;

// Formated credits in the log window
export function fmCredits() {
    console.log(
        "%cmade by %c FUTURE MEDIA %c https://futuremedia.gr",
        "padding:8px 4px; color:#282C35; line-height:24px;",
        "padding:8px 16px; color:#ffffff; background-color:#2DB6F5; line-height:24px;",
        "padding:8px 4px; color:#282C35; line-height:24px;"
    );
}


/**
 * Is the DOM ready?
 *
 * This implementation is coming from https://gomakethings.com/a-native-javascript-equivalent-of-jquerys-ready-method/
 *
 * @param {Function} fn Callback function to run.
 */
export function DomReady( fn ) {
	if ( typeof fn !== 'function' ) {
		return;
	}

	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		return fn();
	}

	document.addEventListener( 'DOMContentLoaded', fn, false );
}